var TabsOrientation;
(function (TabsOrientation) {
    TabsOrientation["VERTICAL"] = "vertical";
    TabsOrientation["HORIZONTAL"] = "horizontal";
})(TabsOrientation || (TabsOrientation = {}));

export { TabsOrientation };
